<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_runningloans']==1 || userData.permissions['loans_report'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <span class="d-flex justify-content-between mb-2">
              <div class="d-flex justify-content-between">
                <div><label>From</label><input class="form-control" v-model="date_from" type="date"></div>
                <div class="mx-1"><label>To</label><input class="form-control" v-model="date_to" type="date"></div>
                <div class="mt-4"><b-button variant="primary"  @click="FilterData"><i class="mdi mdi-filter"></i> Filter</b-button></div>
              </div>
            </span>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(member)="data">
                <b class="text-info">{{ data.item.member.member_id }}</b><br>
                <b class="">{{ data.item.member.name }}</b><br>
              </template>
              <template #cell(loan_type)="data">
                <b><span class="text-info">{{ data.item.loan_type.name }}</span> <br>
                <small>{{ data.item.loan_type.rate }}%</small> &nbsp;&nbsp;&nbsp;
                <small>{{ data.item.loan_type.period }}days</small></b>
              </template>
              <template #cell(amount)="data">
                {{ commas(data.item.amount) }}
              </template>
              <template #cell(payback)="data">
                {{ commas(data.item.payback) }}
              </template>
              <template #cell(repaymentplan)="data">
                {{ commas(data.item.repaymentplan) }} <small class="text-info">/</small> {{ data.item.repaymentstructure }}
              </template>
              <template #cell(paid)="data">
                {{ commas(data.item.paid) }}
              </template>
              <template #cell(expirydate)="data">
                <span>{{ data.item.expirydate }}</span> <br>
                <small v-if="data.item.daysleft < 1" class="bg-danger text-white px-1 rounded-1"> {{ Math.abs(data.item.daysleft) }} days passed</small>
                <small class="bg-primary text-white px-1 rounded-1" v-else> {{ data.item.daysleft }} days left</small>
              </template>
              </b-table>
            </div>
            <div class="row">
                <div class="col">
                  <b>Total Loans : {{ commas(totalloan) }}</b>
                </div>
                <div class="col text-center">
                  <b>Total Paid : {{ commas(totalpaid) }}</b>
                </div>
                <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                        <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to view Due Loans</span></center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
// import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { dueloanMethods, dueloanComputed} from "@/state/helpers";

export default {
  page: {
    title: "Due Loans",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Due Loans",
      items: [ {text: "Dashboard",to: "/",}, {text: "Due Loans",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'member', label: 'Member', visible: true },
          { key: 'loan_type', label: 'Loan Product', visible: true },
          { key: 'amount', label: 'Loan', visible: true },
          { key: 'interest', label: 'Interest', visible: true },
          { key: 'repaymentplan', label: 'Repayment Plan', visible: true },
          { key: 'paid', label: 'Amount Paid', visible: true },
          { key: 'expirydate', label: 'Expiry Date', visible: true },
        ],
      date_to:new Date().toLocaleDateString('fr-CA'),
      date_from:new Date().toLocaleDateString('fr-CA'),
    };
  },
  computed: {
    ...dueloanComputed,
    List() { return this.dueloans.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.dueloans.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.dueloans.length>0) { a=false;} else { a=true;} return a },
    totalloan(){ var total = 0; this.dueloans.forEach((item)=>{ var item_total = item.amount; total = Number(total)+Number(item_total);}); return total },
    totalpaid(){ var total = 0; this.dueloans.forEach((item)=>{ var item_total = item.paid; total = Number(total)+Number(item_total);}); return total },
  },
  mounted() {
    this.fetchDueLoans();
    this.TotalRows = this.dueloans.length;
    this.isBusy=false;
  },
  methods: {
    ...dueloanMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    FilterData() {
        this.filterDueLoans({datefrom:this.date_from,dateto:this.date_to});
      },
  },
};
</script>